export default "__VITE_PUBLIC_ASSET__9a0914db__"